import * as Sentry from '@sentry/react';
import Lottie from 'lottie-react';
import { useEffect, useRef, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as ScanditSDK from 'scandit-sdk';
import { BarcodePicker } from 'scandit-sdk';
import { useTheme } from 'styled-components';
import { addToCart, getCartInfo } from '../actions/cartActions';
import { scanDisplay } from '../actions/scanActions';
import { checkMidiDealEligibility, logMidiDealEvent } from '../actions/midiDealActions';
import { useAddToCart } from '../hooks/useAddToCart';
import {
  ACCOUNT,
  ADD_FID_CARD,
  ADD_FID_SCAN,
  HOME,
  NUMBER_SCREEN,
  SCAN,
  STORE_LIST,
} from '../constants/routes';
import ScannerTest from '../scanner/ScannerTest';
import closeArrow from '../styles/img/account/closeArrow.svg';
import successLottie from '../styles/lottie/success.json';
import { vidercache } from '../utils/ClearCache';
import { notifyWarning } from '../utils/Notify';
import { formatPrice, truncate } from '../utils/StringUtils';
import { isAppPWA } from '../utils/helper-functions';
import CartLength from './CartLength';
import FooterCart from './FooterCart';
import Menu from './Menu';
import ScanditInit from './Scandit/Sandit.js';
import Scanner from './Scanner';
import BackButton from './button/BackButton';
import PrimaryButton from './button/PrimaryButton';
import { StoreVerifModal } from './modals/storeVerifMoadal.jsx';
import { ReloadPage } from './tile/ReloadPage';

import { checkStateCartItems } from '../utils/cartItem.js';
import { GeolocationWrongStoreModal } from './geolocation/modal/GeolocationWrongStoreModal.jsx';

import clsx from 'clsx';
import DemoProduct from '../pages/scan/DemoProduct.jsx';
import { MidiDealProductScan } from './midiDeal/MidiDealProductScan';
import { shouldShowMidiDealOverlay, shouldShowMidiDealProgress, getMidiDealCategoriesPresence } from '../utils/MidiDealUtils';
import { useFunnelTracking } from '../posthog/funnelTracking';
import { isOlderThan30Minutes } from '../utils/date-helper';
import TagNutriscore from './nutriscore/tagNutriscore.jsx';
import { convertToMegaByte } from '../utils/scanSettingsConvert.js';
import useAxios from '../axios/useAxios';
import { usePerformanceContext } from '../context/PerformanceContext.jsx';
import { useOrderLogger } from '../hooks/useOrderLogger';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { useLocation } from 'react-router-dom';
import { CREATE_FID_CARD_CASHBACK } from '../constants/routes';
import { MidiDealProgressBar } from './midiDeal/MidiDealProgressBar.jsx';

const Scan = () => {
  window.scrollTo(0, 0);
  const navigate = useNavigate();
  const theme = useTheme();
  const { cartItems, loadingCart } = useSelector((state) => state.cart);
  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.user);
  const { eligibility, dealActive } = useSelector((state) => state.midiDeal || {});
  const scanTimer = 1000;
  const focusref = useRef(null);
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const [_access, setAccess] = useState(true);
  const [Code, setCode] = useState();
  const [product, setProduct] = useState();
  const [loading, setLoading] = useState(false);

  const [popup, setPopup] = useState(false);
  const [qty, setQty] = useState(1);

  const [isNavbarHidden, setIsNavbarHidden] = useState(false);
  const countItems = CartLength();
  const [isPaused, setIsPaused] = useState(
    !!(store && countItems >= store?.item_limit),
  );
  const [isDestroy, _setIsDestroy] = useState(false);
  const [cartFullPopup, setCartFullPopup] = useState(false);
  const [isScanditLoaded, setIsScanditLoaded] = useState(false);
  const [seeReloadButton, setSeeReloadButton] = useState(false);
  const animProductRef = useRef(null);
  const [fidCardSuccess, setFidCardSuccess] = useState(false);
  const [, setRating] = useState(null);
  const [, setRatingCount] = useState(null);
  const [scannerLoadTimer, setScannerLoadTimer] = useState(null);
  const [scannerLoadStartTime, setScannerLoadStartTime] = useState(null);
  const [isLoadingScanner, setIsLoadingScanner] = useState(true);
  const [quickAddProducts, setQuickAddProducts] = useState([]);
  const location = useLocation();
  const [showMidiDealOverlay, setShowMidiDealOverlay] = useState(false);
  const [showMidiDealProgress, setShowMidiDealProgress] = useState(false);
  const [showMidiDealCompleteAnim, setShowMidiDealCompleteAnim] = useState(false);
  const mididealAlreadyActive = useRef(cartItems?.midiDeal?.isActive);

  window.scrollTo(0, 0);
  document.body.scrollTop = 0;

  // hooks
  const isPWA = isAppPWA();
  const { markComplete } = usePerformanceContext();
  const { logScannerSlowLoading } = useOrderLogger();

  const { trackPageViewScan } = useFunnelTracking();

  const ref = useRef();
  const refreshScan = () => setAccess(true);

  useEffect(() => {
    trackPageViewScan({});
  }, [trackPageViewScan]);

  const handleClosePopupFid = (redirection) => {
    if (redirection === 'account') {
      localStorage.setItem('PREV_LOGIN_PAGE', SCAN);
      navigate(NUMBER_SCREEN, { state: { prevPage: SCAN } });
    } else {
      setFidCardSuccess(true);
      setTimeout(() => {
        setIsPaused(false);
        setPopup(false);
      }, 2400);
    }
  };

  const handleQuickAddProducts = async () => {
    if (!store?.quickAddProducts || store.quickAddProducts.length === 0) {
      return;
    }

    if (!cartItems?._id || !cartItems?.storeId) {
      notifyWarning('Erreur', 'Panier non disponible');
      return;
    }

    try {
      const productPromises = store.quickAddProducts.map((ean) =>
        axiosInstance.get(
          `/products/${cartItems.storeId}/ean13/${ean}`,
          {
            params: {
              orderId: cartItems._id,
            },
          }
        )
      );

      const results = await Promise.all(productPromises);

      for (const { data } of results) {
        if (data) {
          setQuickAddProducts((prev) => [...prev, data]);
        }
      }
    } catch (err) {
      console.error('Error adding quick add products:', err);
      notifyWarning('Erreur', 'Impossible d\'ajouter certains produits');
    }
  };

  const handleJustClosePopupFid = () => {
    setPopup(false);
    setIsPaused(false);
    setFidCardSuccess(false);
  };

  const handleScanPause = (scanPause) => setIsPaused(scanPause);

  useEffect(() => {
    if (cartItems?.isPaid) {
      if (store?.id) {
        navigate(`/?ok=${store.id}`);
      } else {
        console.info('NO STORES');
        navigate('/');
      }
    }
  }, [cartItems]);

  useEffect(() => {
    if (store && countItems >= store?.item_limit) {
      setIsPaused(true);
      setCartFullPopup(true);
    } else {
      setIsPaused(false);
      setCartFullPopup(false);
    }
  }, [countItems]);

  useEffect(() => {
    const fetchStoreAndInit = async () => {
      if (store?.id) {
        try {
          const response = await axiosInstance.get(`/store/${store.id}`);
          if (!response?.data?.live) {
            notifyWarning(
              'Magasin indisponible',
              'Ton magasin est momentanément indisponible. Réessaie plus tard ou sélectionne-en un autre depuis ton menu.',
              'Fermer',
            );
            navigate(HOME);
          }
        } catch (err) {
          console.error('Error during initialization:', err);
        }
      }
    };

    fetchStoreAndInit();
    checkStateCartItems(
      JSON.parse(localStorage.getItem('cartItems')),
      navigate,
      dispatch,
    );
  }, []);

  const scanSettingsData = {
    enabledSymbologies: ['ean8', 'ean13', 'upca', 'code128', 'qr'],
    codeDuplicateFilter: 2500,
    searchArea: { x: 0.025, y: 0.23, width: 0.95, height: 0.35 },
    maxNumberOfCodesPerFrame: 1,
    globPatterns: ['**/*.{css,html,ico,png,svg,woff2}', '**/*.{wasm,js}'],
    maximumFileSizeToCacheInBytes: convertToMegaByte(6) || 6 * 1024 * 1024,
    ignoreURLParametersMatching: [/^v/],
  }

  const getScanSettings = () => {
    return new ScanditSDK.ScanSettings(
      scanSettingsData
    );
  };

  const incQty = () => {
    if (countItems + qty >= store?.item_limit) return;

    setQty(qty + 1);
  };
  const decQty = () => {
    if (qty - 1 <= 0) return;

    setQty(qty - 1);
  };

  const goBackUser = () => {
    const redirectRoute = user?._id ? ACCOUNT : HOME;
    navigate(redirectRoute);
  };

  useEffect(() => {
    const handleChange = () => {
      dispatch(scanDisplay(false));
    };
    return () => {
      window.removeEventListener('beforeunload', handleChange());
    };
  }, []);

  const addToCartHandler = async () => {
    handleAddToCartComplete();

    if (product) {
      setShowMidiDealOverlay(false);
      const result = await addToCartWithAnimation(product, qty);

      if (!result.success) {
        console.error('Failed to add product to cart:', result.error);
      } else {
        console.info('Product added to cart successfully', {
          animated: result.animated,
          warning: result.warning
        });
      }
    }
  };

  useEffect(() => {
    setShowMidiDealOverlay(shouldShowMidiDealOverlay(eligibility, cartItems, product));
    setShowMidiDealProgress(shouldShowMidiDealProgress(eligibility, cartItems, product));
  }, [eligibility, product, cartItems]);

  useEffect(() => {
    let timer;
    const isCurrentlyActive = cartItems?.midiDeal?.isActive;
    if (isCurrentlyActive && !mididealAlreadyActive.current) {
      setShowMidiDealCompleteAnim(true);
      timer = setTimeout(() => {
        setShowMidiDealCompleteAnim(false);
      }, 3500);
    }
    mididealAlreadyActive.current = isCurrentlyActive;
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [cartItems?.midiDeal?.isActive]);

  useEffect(() => {
    if (showMidiDealProgress && store?.midiDeal?.enabled) {
      const currentStep = [hasMain, hasSnack, hasDrink].filter(Boolean).length;
      dispatch(logMidiDealEvent(axiosInstance, {
        event: 'midideal.ui.progress_shown',
        orderId: cartItems?._id,
        storeId: store.id,
        midiDealData: {
          dealPrice: store.midiDeal?.dealPrice,
          timeSlot: store.midiDeal?.timeSlot,
          dealActive,
          currentStep,
          totalSteps: 3,
        },
      }));
    }
  }, [showMidiDealProgress]);

  async function getProduct() {
    if (Code) {
      try {
        setLoading(true);
        setIsNavbarHidden(false);
        setShowMidiDealOverlay(false);
        console.info({ Code });
        const { data } = await axiosInstance.get(
          `/products/${cartItems.storeId}/${Code.symbology}/${Code.data}`,
          {
            params: {
              orderId: cartItems._id,
            },
          },
        );

        if (data) {
          dispatch(
            checkMidiDealEligibility(Code.data, cartItems.storeId, axiosInstance),
          );
        }

        if (data.rating && data.ratingCount) {
          console.info('getProduct rating', data.rating);
          setRating(data.rating);
          setRatingCount(data.ratingCount);
        }

        setProduct(data);
        setLoading(false);

        setQty(1);
        setTimeout(refreshScan, scanTimer);

      } catch (err) {
        console.error('getProduct', err);
        setLoading(false);
        setCode();

        notifyWarning('Article non trouvé', 'Veuillez réessayez !');
        setAccess(true);
      }
    }
  }

  useEffect(() => {
    if (Code) {
      getProduct();
    }
  }, [Code]);

  useEffect(() => {
    if (cartItems?._id && !isOlderThan30Minutes(cartItems?.createdAt)) {
      dispatch(getCartInfo(cartItems._id, axiosInstance));
    }
  }, []);

  useEffect(() => {
    if (cartItems?._id && store?.quickAddProducts && store.quickAddProducts.length > 0) {
      handleQuickAddProducts();
    }
  }, [cartItems?._id, store?.quickAddProducts]);

  useEffect(() => {
    const startTime = Date.now();
    setScannerLoadStartTime(startTime);
    let scannerLoadTimeToLog = 10000;

    const slowLoadingTimer = setTimeout(() => {
      if (isLoadingScanner) {
        if (cartItems?._id && logScannerSlowLoading) {
          logScannerSlowLoading(cartItems._id, user?._id, {
            loadingDuration: Date.now() - startTime,
            scannerType: isPWA ? 'ScannerTest' : 'Scanner',
            deviceType: 'mobile',
            storeId: store?._id,
            sessionId: sessionStorage.getItem('sessionId') || 'unknown',
            platform: 'web',
          });
        }
      }
    }, scannerLoadTimeToLog);

    setScannerLoadTimer(slowLoadingTimer);

    return () => {
      if (slowLoadingTimer) clearTimeout(slowLoadingTimer);
    };
  }, []);

  useEffect(() => {
    if (!isLoadingScanner && scannerLoadTimer) {
      clearTimeout(scannerLoadTimer);
      setScannerLoadTimer(null);
    }
  }, [isLoadingScanner, scannerLoadTimer]);

  const productPopup = () => {
    console.info('productPopup');
    if (product) {
      setProduct(false);
      setCode(0);
      setShowMidiDealOverlay(false);
    }
  };

  const handleCheckMenu = (checkMenu) => {
    console.info('Checkbox payment changed:', checkMenu);
    product.menu = checkMenu;
  };

  useEffect(() => {
    const initScandit = async () => {
      await ScanditInit();
      setIsScanditLoaded(true);
      if (focusref?.current) {
        focusref.current.focus();
      }
      setTimeout(() => {
        setSeeReloadButton(true);
      }, 6000);
    };

    initScandit();
  }, []);

  const handleShowFooter = () => ref.current.onClickInfooter();
  const reloadPageRef = useRef(null);

  // Fonction pour appeler le reset du timer
  const handleResetToaster = () => {
    if (reloadPageRef.current) {
      reloadPageRef.current.resetJustTimer();
    }
  };

  const handleStoreSelection = () => {
    const encodedStoreName = encodeURIComponent(
      store?.name?.split(' ')[0].toLowerCase() || '',
    );
    navigate(`${STORE_LIST}?view=stores&company=${encodedStoreName}`, {
      state: { prevPage: SCAN },
    });
  };

  const isToolkitEnabled =
    process.env.REACT_APP_TOOLKIT?.toUpperCase() === 'TRUE';
  const isDevOrStageEnv =
    process.env.NODE_ENV === 'development' || isToolkitEnabled;


  useEffect(() => {
    const isPageUsable =
      cartItems &&
      isScanditLoaded &&
      !isLoadingScanner &&
      !isPaused &&
      !loading &&
      !loadingCart;

    if (isPageUsable && markComplete) {
      markComplete();
    }
  }, [cartItems, isScanditLoaded, isLoadingScanner, isPaused, loading, loadingCart, markComplete]);

  const { addToCartWithAnimation, handleAddToCartComplete } = useAddToCart({
    cartItems,
    dispatch,
    addToCart,
    axiosInstance,
    setProduct,
    setCode,
    setIsNavbarHidden,
    setIsPaused,
    setLoading,
    animProductRef,
    countItems,
    store
  });

  const isJackpotMatchUsable = cartItems?.jackpot?.isAvailable && cartItems?.jackpot?.isActive && cartItems?.jackpot?.amount > 0;
  const [hasChangeAmountJackpotScreen, setHasChangeAmountJackpotScreen] = useLocalStorage('hasChangeAmountJackpotScreen');

  useEffect(() => {
    console.info('location.state', location.state);
    if (location.state && location.state?.previousRoute === CREATE_FID_CARD_CASHBACK) {
      setTimeout(() => {
        ref.current?.forceOpenCart();
      }, 700);
    }
  }, [location.state?.previousRoute]);

  useEffect(() => {
    if (hasChangeAmountJackpotScreen && isJackpotMatchUsable) {
      setHasChangeAmountJackpotScreen(null);

      setTimeout(() => {
        console.info('onClickInfooter');
        ref.current?.forceOpenCart()
      }, 1000);
    }
  }, [isJackpotMatchUsable, hasChangeAmountJackpotScreen, setHasChangeAmountJackpotScreen]);

  // Midi Deal Logic Helpers
  const { hasMain, hasSnack, hasDrink } = getMidiDealCategoriesPresence(cartItems);
  const savingsAmount = cartItems?.midiDeal?.savings || 0;
  const productPrice = product?.promoPrice || product?.price;
  const isMidiDealComplete = showMidiDealCompleteAnim || cartItems?.midiDeal?.isActive;

  console.log('[DEBUG] localStorage.store:', localStorage.getItem('store'));
  console.log('[DEBUG] parsed:', JSON.parse(localStorage.getItem('store') || '{}'));

  return (
    <>
      {cartItems ? (
        <>
          <BackButton onClick={goBackUser} isAbsolute isChevron />

          {isLoadingScanner ? null : (
            <>
              {/* {store?.api === 'match' ? <StoreVerifModal /> : null} */}
              <GeolocationWrongStoreModal
                setCode={setCode}
                setProduct={setProduct}
              />
            </>
          )}

          <div className="store_adresse">
            {store?.id ? (
              <div className="flex gap-2 items-center justify-center">
                <div className="store_logo_mini">
                  <img src={store.logo} alt={store.name} />
                </div>
                <div className="store_name">{store.name}</div>
                <div className="store_chevron" onClick={handleStoreSelection}>
                  <FaChevronDown />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div ref={focusref} id="scan-main">
            <div className="min-w-full min-h-full overflow-hidden text-white bg-black ">
              <>
                <div
                  className={`popup-fid-scan-container  ${popup ? 'active' : ''}`}
                >
                  <div
                    className="popup-fid-scan-invite"
                    style={{ transform: 'translate(-50%, -50%)' }}
                  >
                    <img
                      src={closeArrow}
                      alt="close"
                      className="popup-fid-scan-close"
                      onClick={handleJustClosePopupFid}
                    />
                    <div
                      className={`popup-fid-scan-question  ${fidCardSuccess ? '' : 'active'}`}
                    >
                      <h1>Tu es en mode invité</h1>
                      <p>
                        Ta carte ne sera pas sauvegardé pour la prochaine fois
                      </p>
                      <button
                        type="button"
                        className="popup-fid-scan-ok"
                        onClick={handleClosePopupFid}
                      >
                        Oui d'accord
                      </button>
                      <PrimaryButton
                        label={'Je créé mon compte'}
                        onClick={() => handleClosePopupFid('account')}
                      />
                    </div>
                    <div
                      className={`popup-fid-scan-success ${fidCardSuccess ? 'active' : ''}`}
                      onClick={() => {
                        setPopup(false);
                        setIsPaused(false);
                        setFidCardSuccess(false);
                      }}
                    >
                      {fidCardSuccess && (
                        <Lottie
                          loop={false}
                          autoplay={true}
                          animationData={successLottie}
                          height={70}
                          width={70}
                        />
                      )}
                      <h1>Carte ajoutée avec succès</h1>
                    </div>
                  </div>
                </div>
                <div
                  className={`backblur-fid-scan  ${popup ? 'active' : ''}`}
                  onClick={() => {
                    setPopup(false);
                    setIsPaused(false);
                    setFidCardSuccess(false);
                  }}
                />

                {loading || loadingCart ? (
                  <>
                    <div
                      className="absolute z-50 w-screen h-screen "
                      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
                    >
                      <div className="z-50 absolute left-2/4 top-[33%]  -translate-x-2/4 ">
                        <div className="lds-spinner white">
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                          <div />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}

                {isDevOrStageEnv ? <DemoProduct setCode={setCode} /> : null}

                {seeReloadButton && (
                  <ReloadPage
                    ref={reloadPageRef}
                    titre="Problème de scanneur ?"
                    message={'Clique ici pour actualiser '}
                    onClick={vidercache}
                    position={'top'}
                  />
                )}

                {store?.midiDeal?.enabled && showMidiDealProgress && (
                  <MidiDealProgressBar
                    selectedMain={hasMain}
                    selectedSnack={hasSnack}
                    selectedDrink={hasDrink}
                    price={`${formatPrice(store?.midiDeal?.dealPrice)}€`}
                    savings={`${formatPrice(savingsAmount)}€`}
                  />
                )}

                {(product || showMidiDealCompleteAnim) && (
                  <MidiDealProductScan
                    open={showMidiDealCompleteAnim || showMidiDealOverlay}
                    price={`${formatPrice(store?.midiDeal?.dealPrice)}€`}
                    topTitle={isMidiDealComplete ? "Midi Deal complété !" : undefined}
                    description={isMidiDealComplete ? "Ton menu est complet *" : undefined}
                  />
                )}

                {isPWA
                  ? isScanditLoaded && (
                    <ScannerTest
                      onClick={productPopup}
                      sdk
                      preloadBlurryRecognition={true}
                      preloadEngine={true}
                      accessCamera={true}
                      guiStyle={BarcodePicker.GuiStyle.VIEWFINDER}
                      viewFinderArea={{
                        x: 0.2,
                        y: 0.23,
                        width: 0.6,
                        height: 0.1,
                      }}
                      onScan={(scanResult) => {
                        setCode(scanResult.barcodes[0]);
                      }}
                      pause={isPaused}
                      destroy={isDestroy}
                      setIsLoadingScanner={setIsLoadingScanner}
                      onProcessFramze
                      scanSettings={getScanSettings()}
                      videoFit={BarcodePicker.ObjectFit.COVER}
                      playSoundOnScan={true}
                      enableCameraSwitcher={true}
                      enablePinchToZoom={false}
                      enableTapToFocus={true}
                      enableTorchToggle={false}
                      mirrorImage={true}
                      targetScanningFPS={10}
                      zoom={0}
                      addTopMargin={-60}
                      size={215}
                    />
                  )
                  : isScanditLoaded && (
                    <Scanner
                      onClick={productPopup}
                      preloadBlurryRecognition={true}
                      preloadEngine={true}
                      accessCamera={true}
                      guiStyle={BarcodePicker.GuiStyle.VIEWFINDER}
                      isLoading={isLoadingScanner}
                      setIsLoading={setIsLoadingScanner}
                      viewFinderArea={{
                        x: 0.2,
                        y: 0.23,
                        width: 0.6,
                        height: 0.1,
                      }}
                      onScan={(scanResult) => {
                        setRating(null);
                        setCode(scanResult.barcodes[0]);
                        handleResetToaster();
                      }}
                      pause={isPaused}
                      destroy={isDestroy}
                      onProcessFramze
                      scanSettings={getScanSettings()}
                      videoFit={BarcodePicker.ObjectFit.COVER}
                      playSoundOnScan={true}
                      enableCameraSwitcher={true}
                      enablePinchToZoom={false}
                      enableTapToFocus={true}
                      enableTorchToggle={false}
                      mirrorImage={true}
                      targetScanningFPS={10}
                      zoom={0}
                    />
                  )}

                <div className="absolute w-full h-fit text-center m-auto top-[60%] overflow-hidden">
                  <p
                    className="text-lg w-screen text-white relative z-[9]"
                    onClick={productPopup}
                  >
                    Scanne le code-barre de tes produits
                  </p>
                </div>
                {cartFullPopup ? (
                  <div
                    id="cartFullPopup"
                    className="absolute top-0 left-0 flex items-center justify-center h-full min-w-full min-h-full overflow-hidden z-[100]"
                  >
                    <div
                      id=""
                      className=" bg-white w-3/4 flex flex-col gap-8 p-8 rounded-[12px] "
                      style={{
                        boxShadow: '0 0 0 100vmax rgb(0 0 0 / 65%)',
                      }}
                    >
                      <div className="flex flex-col items-center justify-center gap-10 ">
                        <p className="mt-4 text-2xl text-center text-black geomanistBold">
                          Ton panier est plein, supprimez des articles pour
                          continuer à scanner.
                        </p>
                      </div>

                      <button
                        type="button"
                        className="relative w-full py-6 mt-4 text-center text-black rounded-full pikko-btn justify-self-end"
                      >
                        <div
                          className="text-2xl text-black"
                          onClick={handleShowFooter}
                        >
                          Se rendre dans le panier
                        </div>
                      </button>

                      <div className="flex items-center justify-around" />
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                <FooterCart
                  handleResetToaster={handleResetToaster}
                  scanPause={handleScanPause}
                  ref={ref}
                  theme={theme}
                  currentProduct={product}
                  quickAddProducts={quickAddProducts}
                />
              </>

              {product ? (
                <>
                  <div
                    className="fixed top-0 left-0 z-20 w-screen h-screen bg-black bg-opacity-70 backdrop-filter1"
                    onClick={productPopup}
                  />
                  <div className="fixed bottom-[20px] w-screen px-4 z-[1750]">
                    <div
                      ref={animProductRef}
                      style={{ '--translate-x': 0, '--translate-y': 0 }}
                      className={`footer-navbar  ${isNavbarHidden
                        ? 'cart-item cart-item-anim visible'
                        : 'hidden'
                        }
                      rounded-full bg-white w-28 h-28 flex items-center justify-center"
                      }`}
                    >
                      <div className="absolute flex items-center justify-center w-24 h-24 inset-x-2/4 inset-y-2/4 -translate-y-2/4 -translate-x-2/4">
                        <img
                          src={product.image}
                          className="max-w-full max-h-full p-2 rounded-full"
                          alt=""
                        />
                      </div>
                    </div>

                    <div
                      id="popup_product"
                      className={clsx(
                        'footer-navbar bg-white mx-4 py-4 px-8 flex flex-col justify-evenly items-center rounded-[16px]',
                        { 'slide-down': isNavbarHidden },
                      )}
                    >
                      <div className="w-full">
                        {product?.nutriscore ? (
                          <div className="flex items-center justify-between h-24 w-full">
                            <div className="text-left">
                              <p className="mb-1 text-2xl font-semibold text-[#909090]">
                                {truncate(product.name, 24)}
                              </p>
                            </div>

                            {product?.nutriscore ? (
                              <div>
                                <TagNutriscore
                                  score={product.nutriscore}
                                  size="md"
                                />
                              </div>
                            ) : null}
                          </div>
                        ) : null}

                        {/* Image and Price */}
                        <div
                          className={clsx(
                            'flex items-center justify-start gap-8 mt-6 h-24 w-full',
                            { '!mt-12': !product?.nutriscore },
                          )}
                        >
                          <div className="border py-2 px-4">
                            <img
                              id="product_img"
                              src={product.image}
                              alt={product.name}
                              className="object-contain w-36 h-36"
                            />
                          </div>

                          <div className="flex flex-col justify-center gap-4">
                            {product?.nutriscore ? null : (
                              <div className="text-left">
                                <p className="mb-1 text-2xl font-semibold text-[#909090]">
                                  {truncate(product.name, 24)}
                                </p>
                              </div>
                            )}

                            <p className="text-4xl text-black">
                              <strong>
                                {' '}
                                {formatPrice(productPrice)}
                                {' €'}
                              </strong>
                            </p>
                          </div>
                        </div>

                        {/* Rating */}
                        {/* <div className="flex flex-col items-start justify-center h-full py-4 ml-4">
                          <div>
                            {rating ? (
                              <div className="product-rating-scan">
                                <span>{rating}</span>
                                <div className="flex items-center justify-center">
                                  <RatingStarFixe
                                    starClassName="w-6"
                                    rating={rating}
                                  />
                                </div>
                                <div className="rating-count">
                                  ({ratingCount})
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div> */}

                        {store ? (
                          <div className="flex justify-between items-center mt-16 mb-4">
                            <div className="rounded-full border-solid border-[#0000000e] pl-7 pr-5 py-2 flex items-center text-2xl mr-6">
                              <button
                                type="button"
                                className="text-[2.5rem] -ml-2 mr-6 px-3 relative bg-slate-100 rounded-full h-10d"
                                onClick={() => decQty()}
                              >
                                -
                              </button>

                              <strong>{qty}</strong>

                              <button
                                type="button"
                                className="bg-slate-100 rounded-full pt-1 px-2 ml-4 text-[2.5rem]"
                                onClick={() => incQty()}
                              >
                                +
                              </button>
                            </div>

                            <div className="flex w-full">
                              <PrimaryButton
                                label="Ajouter au panier"
                                onClick={() => addToCartHandler()}
                                className="shadow-[0_6px_0_#D9CA0C] h-16 w-full"
                              />
                            </div>
                          </div>
                        ) : null}
                      </div>

                      <Menu
                        store={store}
                        product={product}
                        onCheckboxChange={handleCheckMenu}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Scan;
